import { render, staticRenderFns } from "./queueTasks.vue?vue&type=template&id=048598a8&scoped=true&"
import script from "./queueTasks.vue?vue&type=script&lang=js&"
export * from "./queueTasks.vue?vue&type=script&lang=js&"
import style0 from "./queueTasks.vue?vue&type=style&index=0&id=048598a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048598a8",
  null
  
)

export default component.exports